import { ICrudLocale } from '@app/i18n/interface';

export const PROVIDER_CALLS_LOCALE_EN: ICrudLocale = {
  PROVIDER_CALLS: {
    LABEL: { SINGULAR: 'Hotelbeds call', PLURAL: 'Hotelbeds calls' },
    TITLE: 'Hotelbeds calls',
    SUBTITLE:
      'Log of what we send to Hotelbeds and what it answers, uncut. Used to review incidents and for certification.',
    REFRESH: 'Refresh',
    LIST_TITLE: 'Calls of the day',
    LOADING: 'Loading the calls…',
    FIELD: {
      AT: 'Time (UTC)',
      OPERATION: 'Operation',
      STATUS: 'Status',
      DURATION: 'Duration',
      SIZE: 'Size',
      REQUEST: 'Request',
      REFERENCES: 'References',
    },
    OPERATION: {
      AVAILABILITY: 'Availability',
      CHECKRATE: 'Rate check',
      BOOKING: 'Booking',
      BOOKING_DETAIL: 'Booking lookup',
      BOOKING_LIST: 'Booking list',
      CANCELLATION: 'Cancellation',
      STATUS: 'Provider status',
      OTHER: 'Other',
    },
    ATTEMPT: 'attempt {{n}}',
    NO_RESPONSE: 'No response',
    FILTER: {
      DAY: 'Day (UTC)',
      DAY_PLACEHOLDER: 'dd/mm/yyyy',
      OPERATION: 'Operation',
      ALL: 'All operations',
      ALL_WITH_STATUS: 'All, with status checks',
      TEXT: 'Text',
      TEXT_PLACEHOLDER: 'Reference, hotel code or error',
      SEARCH: 'Search',
      HELP: 'The text is matched as-is against what was sent and received: a hotel code, the booking reference (IBSOA-84) or a Hotelbeds reference. Provider status checks only show up if you choose «All, with status checks».',
    },
    COUNT: '{{total}} calls, most recent first. Times in UTC.',
    COUNT_TRUNCATED:
      'Showing the {{shown}} most recent of {{total}}. Narrow the search to see the rest. Times in UTC.',
    EMPTY: 'No calls that day with those filters.',
    FAILED: {
      TITLE: 'The log could not be read',
      DESC: 'The request failed. Try again; if it keeps failing, tell the technical team.',
    },
    BEFORE_RECORD: {
      TITLE: 'Nothing was being recorded that day yet',
      DESC: 'The call log started on {{day}}. Nothing was kept before that.',
    },
    DETAIL: {
      TITLE: 'Hotelbeds call',
      BACK: 'Back to calls',
      REQUEST: 'What we sent',
      RESPONSE: 'What Hotelbeds answered',
      REQUEST_HEADERS: 'Request headers',
      REQUEST_BODY: 'Request body',
      RESPONSE_HEADERS: 'Response headers',
      RESPONSE_BODY: 'Response body',
      COPY: 'Copy',
      COPY_REQUEST_HEADERS: 'Copy the request headers',
      COPY_REQUEST_BODY: 'Copy the request body',
      COPY_RESPONSE_HEADERS: 'Copy the response headers',
      COPY_RESPONSE_BODY: 'Copy the response body',
      COPIED: 'Copied',
      COPY_FAILED: 'Could not copy',
      DOWNLOAD: 'Download',
      HIDDEN_VALUE: 'value hidden',
      NO_HEADERS: 'No headers.',
      NO_BODY: 'No content.',
      NO_RESPONSE: 'Hotelbeds never answered (timeout or network error).',
      ERROR: 'Error',
      NOTE: 'Full request and response, exactly as sent and received. Only the Api-key and X-Signature values are hidden. «Copy» and «Download» give the exact text of the log. Calls of a booking are kept until 6 months after its check-in date (one year at least); all other calls, one year from the day they were made.',
      NOT_FOUND: 'Call not found',
      NOT_FOUND_DESC: 'The link may be wrong, or the call has been deleted: calls of a booking are kept until 6 months after its check-in date (one year at least), all others for one year.',
    },
    ORDER: {
      TITLE: 'Hotelbeds calls',
      SUBTITLE: 'The search the rate came from, the rate check, the booking, its lookups and the cancellation. Times in UTC.',
      LOAD: 'Show the Hotelbeds calls',
      EMPTY: 'No calls recorded for this booking. They are kept until 6 months after the check-in date (one year at least).',
      EMPTY_SINCE: 'No calls recorded for this booking. The log started on {{day}}: earlier bookings have none.',
    },
  },
};
